export default {

  defaultQuery: {
    wordsColumns: [],
    categories: 'all',
    minWords: 1,
    maxWords: 2,
    ignoreSpecialCharacters: true,
    ignoreCase: true
  },

  wordRegex: {
    withoutSpecialChars: /[0-9]+[,\.][0-9]+|[0-9]+|".+"|[\u00C0-\u1FFF\u2C00-\uD7FF\w0-9]+/g,
    withSpecialChars: /".+"|[^ ]+/g
  },

  sumColumns: ['Clicks', 'Impressions', 'Cost', 'Conversions', 'ConversionValue'],

  wordColumnsByType: {
    'searchQueryPerformance' : ['Query'],
    'adPerformance' : ['Headline', 'HeadlinePart1', 'HeadlinePart2', 'HeadlinePart3',
                       'Description', 'Description1', 'Description2']
  }
}



// WEBPACK FOOTER //
// ./src/config/logic/words.js